// extracted by mini-css-extract-plugin
export default {"input":"PracticeTextField_input__+SVne","inputError":"PracticeTextField_inputError__AYkr4"};